import { FormattedMessage } from 'react-intl'
import { Platform, ScrollView, TouchableWithoutFeedback, View } from 'react-native'
import styled, { useTheme } from 'styled-components'
import PropTypes from 'prop-types'
import { H3, Paragraph } from '@flix/common/elements/typography'
import { media } from '@flix/common/style/media'
import { phoneNumbers } from '../../../config/companyDetails.js'
import { cursorPointer } from '../../../style/webStyles'
import messages from './messages'

const Addresses = styled(View)`
  ${media.sm`
    flex-direction: row;
  `}
`

const Emails = styled(View)`
  margin: ${(props) => props.theme.spacing.lg}px 0;
`
const VerticalDivider = styled(View)`
  ${media.sm`
    margin: 0 ${(props) => props.theme.spacing.lg}px;
    width: 2px;
    background: ${(props) => props.theme.colors.white};
  `}
`

export const ContactDetails = ({ showAddresses = true, openMail }) => {
  const theme = useTheme()

  const isWeb = Platform.OS === 'web'

  return (
    <ScrollView contentContainerStyle={!isWeb ? { paddingBottom: theme.spacing.xlarge } : null}>
      <Emails>
        <ContactEmail
          label="tech"
          pleaseEmail
          email="support@flixpremiere.com"
          openMail={openMail}
        />
        <ContactEmail label="billing" email="billing@flixpremiere.com" openMail={openMail} />
        <ContactEmail label="feedback" email="feedback@flixpremiere.com" openMail={openMail} />
        <ContactEmail label="other" email="info@flixpremiere.com" openMail={openMail} />
      </Emails>

      {showAddresses && (
        <Addresses>
          <ContactAddress label="nyAddress">
            16 Madison Square West,
            {'\n'}
            12th Floor,
            {'\n'}
            New York, NY,
            {'\n'}
            10010
            {'\n'}
            {'\n'}T +1 (212) 710 2692
          </ContactAddress>

          <VerticalDivider />

          <ContactAddress label="usAddress">
            468 N Camden Drive,
            {'\n'}
            Suite 200,
            {'\n'}
            Beverly Hills CA,
            {'\n'}
            90210
            {'\n'}
            {'\n'}T {phoneNumbers.US}
          </ContactAddress>

          <VerticalDivider />

          <ContactAddress label="ukAddress">
            48 Warwick Street
            {'\n'}
            Piccadilly
            {'\n'}
            London
            {'\n'}
            W1B 5AW
            {'\n'}
            {'\n'}T {phoneNumbers.GB}
          </ContactAddress>
        </Addresses>
      )}
    </ScrollView>
  )
}

ContactDetails.propTypes = {
  openMail: PropTypes.func.isRequired,
  showAddresses: PropTypes.bool,
}

const ContactEmailContainer = styled(View)`
  margin-bottom: ${(props) => props.theme.spacing.md}px;
`

const EmailLink = styled(Paragraph)`
  ${cursorPointer};
  text-decoration-line: underline;
`

const ContactEmail = ({ label, email, pleaseEmail, openMail }) => {
  return (
    <ContactEmailContainer>
      <H3>
        <FormattedMessage {...messages[label]} />
      </H3>
      <Paragraph>
        {pleaseEmail && (
          <>
            <FormattedMessage {...messages.pleaseEmail} />{' '}
          </>
        )}
        <TouchableWithoutFeedback onPress={() => openMail(email)}>
          <EmailLink>{email}</EmailLink>
        </TouchableWithoutFeedback>
      </Paragraph>
    </ContactEmailContainer>
  )
}

const ContactAddressContainer = styled(View)`
  margin-bottom: ${(props) => props.theme.spacing.md}px;

  ${media.sm`
    margin: 0;
  `}
`

const ContactAddress = ({ label, children }) => (
  <ContactAddressContainer>
    <H3>
      <FormattedMessage {...messages[label]} />
    </H3>
    <Paragraph>{children}</Paragraph>
  </ContactAddressContainer>
)
